/**
 * WordPress dependencies
 */
import { compose } from '@wordpress/compose'
import { RichText } from '@wordpress/block-editor'
import { applyFilters } from '@wordpress/hooks'

/**
 * Internal dependencies
 */
import { name } from './index'
import { range } from '~cartzillagb/util'
import { IconDisplay, BlockContainer } from '~cartzillagb/components'

/**
 * External dependencies
 */
import classnames from 'classnames'

const save = props => {
	const { 
		attributes, 
		className,
	} = props 

	const {
		enableTitle,
		enableSubtitle,
		enableIcon,
		limit,
		lgColumns,
		mdColumns,
	} = attributes

	const mainClasses = classnames( [
		className,
		'czgb-info-card',
	], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

	const content = range( 1, ( limit ) + 1 ).map( i => {

		const Title = attributes[ `title${ i }` ]
		const subTitle = attributes[ `subtitle${ i }` ]
		const Icon = attributes[ `icon${ i }` ]
		const Link = attributes[ `link${ i }` ] !== undefined ? attributes[ `link${ i }` ]  : '#'
		const titleColor = attributes[ `titlecolor${ i }` ]
		const customTitlecolor = attributes[ `customtitlecolor${ i }` ]
		const subtitleColor = attributes[ `subtitlecolor${ i }` ]
		const customSubtitlecolor = attributes[ `customsubtitlecolor${ i }` ]
		const bgColor = attributes[ `bgcolor${ i }` ]
		const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]

		const LargeScreen = 12 / lgColumns
		const MediumScreen = 12 / mdColumns

		let defaulttitle = ''
		let defaultdesc = ''
		let defaultIcon = ''

		if ( (i % 2 ) === 1 ) {
			defaulttitle = "Read the blog"
			defaultdesc = "Latest store, fashion news and trends."
			defaultIcon = 'czi-edit'
		}

		if ( (i % 2 ) === 0 ) { 
			defaulttitle = "Follow on Instagram"
			defaultdesc = "#ShopWithCartzilla"
			defaultIcon ='czi-instagram'
		}

		const bgstyle = { backgroundColor: bgcustomColor && bgcustomColor }

		const titleComp = enableTitle && (
			<RichText.Content
				tagName="h5"
				className={ `h5 mb-1 ${ titleColor ? titleColor : customTitlecolor ? '' : 'text-dark' }` }
				value={ Title || defaulttitle }
				style={ { color: customTitlecolor } }
			/>
		)

		const subtitleComp = enableSubtitle &&  (
			<RichText.Content
				tagName="p"
				value={ subTitle || defaultdesc }
				className={ `font-size-sm ${ subtitleColor ? subtitleColor : customSubtitlecolor ? '' : 'text-muted' }` }
				style={ { color: customSubtitlecolor } }
			/>
		)

		const iconComp = enableIcon && (
			<IconDisplay 
				value={ Icon !== undefined ? Icon : defaultIcon }
				additionalClass="h3 mt-2 mb-4 text-primary" 
			/>    
		)

		const output = (
			<div className={ `col-md-${ MediumScreen } col-lg-${ LargeScreen } info-card` }>
				<a className={ `d-flex border-0 rounded-0 text-decoration-none py-md-4 h-100 align-items-center ${ bgColor ? bgColor : bgcustomColor ? '' : ( i === 1 ? 'bg-faded-primary' : 'bg-faded-accent' ) }` } style={ bgstyle } href={ Link }>
					<div className="card-body text-center">
						{ iconComp }
						{ titleComp }
						{ subtitleComp }
					</div>
				</a>
			</div>
		)
			
			return output
	}   )

	return (
		<div className={ mainClasses }>
			<section className="container-fluid px-0">
				<div className="row no-gutters">
					{ content }
				</div>
			</section>
		</div>
	)
}

export default compose(
)( save )